import { Container } from '@common/layout/container';
import { SubNavigationEntry } from '@common/types/sub-navigation-entry';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Icon } from '@konova/ui/icon';
import { Stack } from '@konova/ui/stack';
import { Typography } from '@konova/ui/typography';
import clsx from 'clsx';
import React, { FC, isValidElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import classes from './document-navigation-bar.module.scss';

export type DocumentNavigationBarProps = {
  /**
   * List of available entrypoints in the navigation bar
   */
  entries: SubNavigationEntry[];
};

export const DocumentNavigationBar: FC<DocumentNavigationBarProps> = ({ entries }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(classes.root, 'document-navigation-bar-component')}>
      <Container>
        <nav className={classes.navBar} aria-label={t('common.aria.sub-navigation')}>
          {entries.map(entry => {
            return entry.enabled !== false ? (
              <Link
                className={classes.link}
                to={entry.url}
                key={entry.url}
                aria-current={entry.active ? 'page' : undefined}
                title={entry.title}
              >
                <Stack
                  crossAxis="center"
                  className={clsx(classes.item, { [classes.active]: entry.active })}
                >
                  {entry.icon
                    && (isValidElement(entry.icon) ? (
                      entry.icon
                    ) : (
                      <Icon icon={entry.icon! as IconProp}/>
                    ))}
                  <Typography variant="caption" bold={entry.active} noWrap>
                    {entry.label}
                  </Typography>
                </Stack>
              </Link>
            ) : null;
          })}
        </nav>
      </Container>
    </div>
  );
};
